import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../services/loginsApi';
import { authenticateActions } from '../store/store';
import { useNavigate } from 'react-router-dom';
import NapidAuthAPI from '../api/napidAuthApi';

const BlockBackNavigation = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken);
  const navigate = useNavigate();

  useEffect(() => {
    const logoutApi = async () => {
      await NapidAuthAPI.logoutUser(accessToken);
      localStorage.removeItem('refreshToken');
      dispatch(authenticateActions.logout());
      navigate('/login');
    };

    const handleBackButton = () => {
      const stayOnPage = window.confirm(
        'Navigating back is disabled for security purposes and will log you out.\n\nDo you want to stay on this page?'
      );

      if (!stayOnPage) {
        logoutApi();
      } else {
        // Push the current state back into the history stack
        window.history.pushState(null, '', window.location.href);
      }
    };

    // Add the initial state
    window.history.pushState(null, '', window.location.href);

    const popStateHandler = (event) => {
      // Prevent default popstate behavior
      event.preventDefault();
      handleBackButton();
    };

    // Add event listeners for popstate
    window.addEventListener('popstate', popStateHandler);

    return () => {
      window.removeEventListener('popstate', popStateHandler);
    };
  }, [accessToken, dispatch, navigate]);

  return null;
};

export default BlockBackNavigation;
